import '.h{width:100%;}.ssr-plugin'
import '.f7{border-radius:0.75rem;}.ssr-plugin'
import '.hd{padding:0.5rem 1rem;}.ssr-plugin'
import '.f3{font-size:1.125rem;}.ssr-plugin'
import '.dz{line-height:1.75rem;}.ssr-plugin'
import '.he{resize:vertical;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { forwardRef, FocusEventHandler } from 'react'
import { InputField } from '../InputField'

export type MultiLineTextInputProps = {
  value: string
  placeholder?: string
  label?: string
  labelStyle?: Style
  required?: boolean
  minHeight?: string
  style?: Style
  errorMessage?: string
  onBlur?: FocusEventHandler<HTMLTextAreaElement>
  setValue: (value: string) => void
}

export const MultiLineTextInput = forwardRef<
  HTMLTextAreaElement,
  MultiLineTextInputProps
>(
  (
    {
      value,
      placeholder,
      label,
      labelStyle,
      required,
      minHeight = '6.5rem',
      style,
      errorMessage,
      onBlur,
      setValue,
    }: MultiLineTextInputProps,
    ref,
  ) => {
    const hasError = !!errorMessage
    return (
      <InputField
        label={label}
        labelStyle={labelStyle}
        required={required}
        errorMessage={errorMessage}
      >
        <styled.textarea className="h f7 hd f3 dz he"
          ref={ref}
          style={{
            minHeight: minHeight,
            border: `1px solid ${hasError ? 'var(--brand-primary)' : 'var(--palette-blue-300)'}`,
            background: hasError
              ? 'var(--status-error-muted)'
              : 'var(--palette-white)',
            '&:focus': {
              outline: 'none',
              border: `1px solid ${hasError ? 'var(--brand-primary)' : 'var(--brand-secondary)'}`,
            },
            ...style,
          }}
          placeholder={placeholder}
          value={value}
          onBlur={onBlur}
          onChange={(e) => setValue(e.target.value)}
        ></styled.textarea>
      </InputField>
    )
  },
)
